import { CURSOR_UPDATE, CURSOR_REMOVE } from './liveCursorConstants';

export const updateCursor = ({ x, y, status, cursorType, userId }) => ({
    type: CURSOR_UPDATE,
    x,
    y,
    status,
    cursorType,
    userId,
    sync: true,
});

export const removeCursor = ({ userId, sync = true, remote = false }) => ({
    type: CURSOR_REMOVE,
    userId,
    sync,
    remote,
});
